<div>
  @switch (type) {
      @case ('price') {
    <ion-list-header>Price Range &nbsp; <small>(0~{{priceRangeMax | currency: currencyConvertService.localCurrency() + ' '}})</small></ion-list-header>
    <ion-item lines="none">
      <ion-range  [dualKnobs]="true"
                  [min]="priceRangeMin"
                  [max]="priceRangeMax"
                  [formControl]="priceRange"></ion-range>
    </ion-item>
    <ion-item lines="none">
      <small slot="start">{{priceRange.value?.lower | currency: currencyConvertService.localCurrency() + ' ' }} </small>
      <small slot="end">{{((priceRange.value?.upper ?? 10) * currencyConvertService.exchangeRates[currencyConvertService.localCurrency()]) | currency: currencyConvertService.localCurrency() + ' '}}</small>
    </ion-item>
      }
    @case ('floor') {
      <ion-list-header>Floor Area</ion-list-header>
      <ion-item lines="none">
        <ion-range [dualKnobs]="true"
                   [min]="propertyService.filterValues().minFloorArea ?? propertyService.filterValuesInitial().minFloorArea"
                   [max]="propertyService.filterValues().maxFloorArea ?? propertyService.filterValuesInitial().maxFloorArea"
                   [formControl]="floorRange"></ion-range>
      </ion-item>
      <ion-item lines="none">
        <small slot="start">{{floorRange.value?.lower}}</small>
        <small slot="end">{{floorRange.value?.upper}}</small>
      </ion-item>
    }
    @case ('age') {
      <ion-list-header>Property Age</ion-list-header>
      <ion-item lines="none">
        <ion-range [dualKnobs]="true"
                   [min]="propertyService.filterValues().minAge"
                   [max]="propertyService.filterValues().maxAge"
                   [formControl]="ageRange">
          <span slot="start">{{ageRange.value?.lower}}</span>
          <span slot="end">{{ageRange.value?.upper}}</span>
        </ion-range>
      </ion-item>
      <div class="ion-padding"></div>
    }
    @case ('beds') {

      <ion-list-header>Bedrooms</ion-list-header>
      <ion-item lines="none">
        <ion-range [formControl]="bedrooms"
                   [min]="1"
                   [max]="10" snaps="true">
          <span slot="end">{{ bedrooms.value }}</span>
        </ion-range>
      </ion-item>
      <div class="ion-padding"></div>
    }
    @case ('furniture') {

      <ion-list-header>Bedrooms</ion-list-header>
      <ion-item lines="none">
        <ion-range [formControl]="bedrooms"
                   [min]="1"
                   [max]="10" snaps="true">
          <span slot="end">{{ bedrooms.value }}</span>
        </ion-range>
      </ion-item>
      <div class="ion-padding"></div>
    }
  }
</div>
